<div style="margin-bottom: 20px;">
  <h4>Program: {{program.name}} <span style='color: var(--p-primary-400)'>Menu Tester</span></h4>
</div>
<div class="flex flex-row w-full">
  <div class="flex flex-col h-96">
    <div>
      <h5>Suppliers</h5>
    </div>
    <!-- <p-dropdown [options]="suppliers" [(ngModel)]="supplierId" optionValue="id" optionLabel="name"
      placeholder="Select a supplier" (onChange)="onSupplierChange($event.value)">
    </p-dropdown> -->
    <p-select [options]="suppliers" [(ngModel)]="supplierId" optionValue="id" optionLabel="name"
      placeholder="Select a supplier" (onChange)="onSupplierChange($event.value)" class="w-full">
    </p-select>
    <!--   <div style="margin-top: 20px; margin-bottom: -10px;">
    <span><h5>Categories</h5></span>
  </div> -->
    <div class="w-full pt-5">
      <p-menu [model]="items">
        <ng-template pTemplate="item" let-item>
          <ng-container *ngIf="item.route; else elseBlock">
          </ng-container>
          <ng-template #elseBlock>
            <a [href]="item.url">
              <span [class]="item.icon"></span>
              <span class="ml-3">{{ item.label }}</span>
            </a>
          </ng-template>
        </ng-template>
      </p-menu>
    </div>
  </div>

  <div class="flex flex-col pl-2">
    <div>
      <h5>
        Select Product ({{ this.filteredProductTypeConfigs.length }} items
        listed)
      </h5>
    </div>
    <div class="flex grow">
      <p-scrollPanel *ngIf="filteredProductTypeConfigs" [style]="{ width: '25vw', height: '74vh' }">
        <p-dataView #dv [value]="filteredProductTypeConfigs">
          <ng-template #list let-productTypeConfigs pTemplate="listItem">
            <div *ngFor="let productTypeConfig of productTypeConfigs">
              <div class="flex flex-row" (click)="onSelectProduct(productTypeConfig, $event)">
                <div class="job-order-product-card w-1/3 flex items-center justify-center">
                  <img class="shadow-2 border-round" class="justify-center"
                    style="max-height: 150px; width: 150px; object-fit: scale-down" [src]="getListImageUrl(productTypeConfig) || '/assets/proximity/no-thumbnail-mid.png'" />
                </div>
                <div class="flex flex-col flex-1 mb-6 ml-2 gap-2 cursor-pointer">
                  <div class="flex mt-8">
                    <p class="text-2xl line-height-2">
                      {{productTypeConfig.pricedProductType.productType.name}}
                    </p>
                  </div>
                  <div class="flex">
                    <h6>
                      Supplier:
                      {{
                      productTypeConfig.pricedProductType.productType.supplier.name
                      }}
                    </h6>
                  </div>
                  <div class="flex" style="margin-top: -10px">
                    <h6>
                      Manufacturer: {{productTypeConfig.pricedProductType.productType.manufacturer.name}}
                    </h6>
                  </div>
                  <div class="flex" style="margin-top: -10px">
                    <h6>
                      Product Id: {{productTypeConfig.pricedProductType.productType.productKey}}
                    </h6>
                  </div>
                  <div class="flex" style="margin-top: -10px">
                    <h6>Config Name: {{ productTypeConfig.name }}</h6>
                  </div>
                  <div>
                    <div style="padding-right: 10px">
                      <span class="text-2xl font-semibold">{{
                        productTypeConfig.pricedProductType?.basePrice
                        | currency
                        }}
                        <span class="text-sm">base price</span>
                      </span>
                      <!-- <span *ngIf="isInCart(productTypeConfig)" style="float: right"><p-button
                          icon="pi pi-shopping-cart" class="mr-4 mb-2 p-button-rounded"></p-button></span> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </p-dataView>
      </p-scrollPanel>
    </div>
  </div>
</div>